import React from "react";
import { Container } from "@mui/material";
import ContactForm from "../components/contactForm/ContactForm";
import ContactCard from "../components/contactCard/ContactCard";
import ContactMap from "../components/contactMap/ContactMap";

function ContactPage() {
  return (
    <>
      <ContactForm />
      <Container 
        maxWidth="xl" 
        sx={{ 
          padding: 0,
        }}
      >
        <ContactCard /> 
      </Container>
      <ContactMap />
    </>
  );
}

export default ContactPage;